import script from "./LowResolutionCleanupAction.vue?vue&type=script&setup=true&lang=js"
export * from "./LowResolutionCleanupAction.vue?vue&type=script&setup=true&lang=js"

import "./LowResolutionCleanupAction.vue?vue&type=style&index=0&id=602daaf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602daaf6"]])

export default __exports__